import React from "react";
import {
  FieldMappingMetaResponse,
  LinkedAccount,
  FieldMappingOptionsResponse,
  FieldMappingInstance,
  FieldMappingTarget,
  FieldMappingCreationAndEditDict,
  FieldMappingPathways,
  FieldMappingModalStep,
} from "../../../../../../../models/Entities";
import { FieldMappingCommonModelConfiguration } from "../../../../../../../models/Entities";

interface FieldMappingModalContextState {
  linkedAccount: LinkedAccount | null;
  setModalStep: (modalStep: FieldMappingModalStep) => void;
  onModalClose: () => void;
  linkedAccountMappingInfo: FieldMappingMetaResponse | {};
  linkedAccountFieldMappingOptions: FieldMappingOptionsResponse | undefined;
  enabledCommonModels: Array<string>;
  commonModelsToMappingConfig: { [common_model_id: string]: FieldMappingCommonModelConfiguration };
  fieldMappingTargets: Array<FieldMappingTarget>;
  fieldMappingInstances: Array<FieldMappingInstance>;
  selectedRemoteField: FieldMappingCreationAndEditDict | null;
  setSelectedRemoteField: (selectedRemoteField: FieldMappingCreationAndEditDict | null) => void;
  selectedCommonModel: string | null;
  setSelectedCommonModel: (selectedCommonModel: string | null) => void;
  selectedFieldMappingPathway?: FieldMappingPathways;
  setSelectedFieldMappingPathway: (selectedFieldMappingPathway: FieldMappingPathways) => void;
  jsonAdvancedMappingExpression: string | null;
  setJsonAdvancedMappingExpression: (jsonAdvancedMappingExpression: string | null) => void;
  setCustomMappingMetaResponse: (data: FieldMappingMetaResponse) => void;
}

const FieldMappingModalContext = React.createContext<FieldMappingModalContextState>({
  linkedAccount: null,
  setModalStep: () => {},
  onModalClose: () => {},
  linkedAccountMappingInfo: {},
  enabledCommonModels: [],
  commonModelsToMappingConfig: {},
  linkedAccountFieldMappingOptions: undefined,
  fieldMappingTargets: [],
  fieldMappingInstances: [],
  selectedRemoteField: null,
  setSelectedRemoteField: () => {},
  selectedCommonModel: null,
  setSelectedCommonModel: () => {},
  selectedFieldMappingPathway: undefined,
  setSelectedFieldMappingPathway: () => {},
  jsonAdvancedMappingExpression: null,
  setJsonAdvancedMappingExpression: () => {},
  setCustomMappingMetaResponse: () => {},
});

export default FieldMappingModalContext;
